import React from 'react';
import { Link } from 'wouter';
import { useObserver, useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { AppLocation } from '../../AppLocation';
import { useResolve } from '../../Container';
import { WorkspaceModel } from '../../dashboard/Models';
import { NavMenu } from './NavMenu';

export const UserMenuBlock = () => {

    const location = useObserverReturningStore(useResolve(AppLocation));
    const workspace = useObserver(useResolve(WorkspaceModel));

    return <NavMenu>
        <Link to="/recent">
            <NavMenu.Item active={location.includes('view', 'recent')}>
                <NavMenu.ItemIcon>
                    <Icon src="deqo://icons/hero/clock" />
                </NavMenu.ItemIcon>
                <NavMenu.ItemLabel>
                    Recent Boards
                </NavMenu.ItemLabel>
            </NavMenu.Item>
        </Link>
        <Link to="/templates">
            <NavMenu.Item active={location.includes('view', 'templates')}>
                <NavMenu.ItemIcon>
                    <Icon src="deqo://icons/dash/templates" />
                </NavMenu.ItemIcon>
                <NavMenu.ItemLabel>
                    Templates
                </NavMenu.ItemLabel>
            </NavMenu.Item>
        </Link>
    </NavMenu>;
};

